import AvatarWithIcon from "./AvatarWithIcon";

export default AvatarWithIcon;
